import React, {useState, useEffect} from 'react';

import { withRouter } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStoreActions, useStoreState } from "easy-peasy";

function SetTimezone() {
  const [timezone, setTZ] = useState('');
  const setTimezone = useStoreActions(actions => actions.timezone.setTimezone);
  const timezones = useStoreState(state => state.timezone.timezones);
  const account_id = useStoreState(state => state.account_id);
  const account = useStoreState(state => state.account.account);

  useEffect(() => {
    setTZ(account.timezone);
  }, [account, account_id]);

  const handleChange = (e) => {
    setTZ(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setTimezone(timezone)
    .then(response => {
      if (response.status === "success") {
        window.alert("Success!");
        account.timezone = timezone;
      } else {
        window.alert(response.error);
      }
    });
  };

  return (
    <>
    <div className="col-12">
      <h1 className="text-center">Set Timezone</h1>
      <p>This will set the timezone for times shown in your Opened Report.</p>
    </div>
    <Form id="signup" className="row d-flex justify-content-center mx-3" onSubmit={handleSubmit}>
      <div className="col-12 col-md-6 mx-auto bg-white shadow rounded py-3 m-3 m-sm-0">
        <Form.Group className="col-12">
          <Form.Label>Timezone</Form.Label>
          <Form.Select onChange={handleChange} value={timezone}>
            {timezones && timezones.map(tz => (
              <option key={tz} value={tz}>{tz}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <div className="col-12">
          <Button type="submit" variant="danger btn-lg w-100 text-uppercase">Submit</Button>
        </div>
      </div>
    </Form>
    </>
  );
}

export default withRouter(SetTimezone);
